module.exports = __webpack_public_path__ + "img/Veronika_kendoje_3.bce85b9f.jpg";